
import {
  defineComponent,
  PropType,
  onMounted,
  reactive,
  Ref,
  ref,
  toRefs,
} from "vue";
import $api from "@/api/main";

export default defineComponent({
  props: {
    /**
     * @param {Array} 当前组件的值
     */
    modelValue: {
      type: Array,
      default: (): any => {
        return [];
      },
    },
    style: {
      type: String,
      default: (): any => {
        return "";
      },
    },
    size: {
      type: String,
      default: (): any => {
        return "";
      },
    },
    disabled: {
      type: Boolean,
      default: (): any => {
        return false;
      },
    },
  },
  setup(props, ctx) {
    /**
     * @param 设置modelvalue 以及 级联器多级属性
     */
    const state = reactive({
      cascaderProps: {},
      modleData: props.modelValue,
    });

    // 级联组件的自定义 props
    state.cascaderProps = {
      emitPath: true,
      value: "areaCode",
      label: "labelName",
      checkStrictly: true,
      lazy: true,
      // 懒加载方法
      lazyLoad(node: any, resolve: any) {
        // 定义省市区数据方法的字典
        const requestDir: any = {
          0: "getProvince",
          1: "getCity",
          2: "getArea",
        };
        const { level, value } = node;
        // 根据当前节点获取下级数据
        eval(requestDir[level])(value).then((dataList: any) => {
          // 当level 为 2时则判断为子节点   此处可以优化
          if (level === 2) {
            if (dataList.length == 0) {
              node.children = undefined;
              node.leaf = true;
            }
            let temp = JSON.parse(JSON.stringify(dataList));
            temp.map((item: any) => {
              item["leaf"] = true;
            });
            resolve(temp);
          } else {
            resolve(dataList);
          }
        });
      },
    };

    // 选择级联菜单的响应事件
    const handleAreaChange = (val: any) => {
      state.modleData = val;
      ctx.emit("update:modelValue", val);
    };

    /**
     * 请求省数据
     */
    const getProvince = async () => {
      let res = await $api.getProvinceData();
      res.forEach((item: any) => {
        item.labelName = item.provinceName;
      });
      return res;
    };

    /**
     * 请求市数据
     */
    const getCity = async (params: any) => {
      let res = await $api.getCityData(params);
      res.forEach((item: any) => {
        item.labelName = item.cityName;
      });
      return res;
    };
    /**
     * 请求县数据
     */
    const getArea = async (params: any) => {
      let res = await $api.getAreaData(params);
      res.forEach((item: any) => {
        item.labelName = item.districtName;
      });
      return res;
    };

    // 暴露需要引用的值
    return {
      handleAreaChange,
      ...toRefs(state), //toRefs() 将数据变成响应式数据
    };
  },
});
